<template>
  <div>
    <header class="main-header">
        <a href="#" class="logo" style="position: fixed;">
            <!-- mini logo for sidebar mini 50x50 pixels -->
            <span class="logo-mini"><img style="max-width: 35px;" src="../../assets/circle-logo.png"></span>
            <!-- logo for regular state and mobile devices -->
            <span class="logo-lg"><img src="../../assets/circle-logo.png"></span>
        </a>
        <!-- Header Navbar: style can be found in header.less -->
        <nav class="navbar navbar-static-top">
            <div class="container">
                <div class="navbar-header">
                    <a @click="dashboard" class="navbar-brand"><img style="max-width: 35px;" src="../../assets/circle-logo.png"></a>
                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
                        <i class="fa fa-bars"></i>
                    </button>
                </div>
                <!-- Collect the nav links, forms, and other content for toggling -->
                <div class="navbar-collapse pull-left collapse" id="navbar-collapse" aria-expanded="false" style="height: 1px;">
                    <ul class="nav navbar-nav">
                        <li v-bind:class="{'active': url == 'DashboardV3' || url == '/dashboard_v3'}"><a v-on:click="navigation('DashboardV3')">Home <span class="sr-only">(current)</span></a></li>
                        <li class="dropdown" v-bind:class="{'active': url == 'ReportV3'}">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown">Report <span class="caret"></span></a>
                            <ul class="dropdown-menu" role="menu">
                              <li><a v-on:click="navigation('ReportV3')" >Interview Report</a></li>
                              <!-- v-if="email == 'naren.v@screenit.io'" -->
                              <li v-if="userInfo.master_id == null"><a v-on:click="navigation('SheduleReportv3')" >Schedulelist Report</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <!-- /.navbar-collapse -->
                <!-- Navbar Right Menu -->
                <div class="navbar-custom-menu">
                    <ul class="nav navbar-nav">
                        <li class="dropdown notifications-menu">
                          <addpostjd v-if="createPostJd == true" :resumefiles="resumefiles1" @createpostjd_emit="onclose()" :shwovalueAddPost="createPostJd"></addpostjd>
                          <addpost v-if="createPost == true" :resumefiles="resumefiles" @createpost_emit="onclose()" :shwovalueAddPost="createPost"></addpost>
                          <!-- <button class="mt-2 mr-2 roundedButton" type="button" @click="uploadJd = true; resumefiles1 = []">Upload JD</button> -->
                          <!-- <button class="mt-2 mr-2 roundedButton" type="button" @click="uploadId = true; resumefiles1 = []">Upload ID</button> -->
                            <a class="dropdown-toggle" data-toggle="dropdown">
                              <span style="color: white; font-size: 14px; font-weight:bold;">Upload </span><i style="color: white; font-size: 20px" class="fa fa-cloud-upload"></i>
                            </a>
                            <ul class="dropdown-menu logmenu" style="width: 210px;">
                              <li>
                                  <ul class="menu">
                                    <li>
                                        <a @click="uploadId = true; resumefiles = []">Interviewer Description</a>
                                    </li>
                                    <li>
                                        <a @click="uploadJd = true; resumefiles1 = []">Job Description</a>
                                    </li>
                                  </ul>
                              </li>
                            </ul>
                        </li>
                        <!-- <li class="dropdown messages-menu">
                          <a @click="iaas()"><span style="color: white; font-size: 14px; font-weight:bold;">IaaS </span><i style="color: white; font-size: 16px" class="fa fa-external-link-square"></i></a>
                        </li> -->
                        <li class="dropdown messages-menu">
                        </li>
                        <li class="dropdown notifications-menu">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" @click="getnotification()">
                            <img src="../../assets/img/notify-bell.svg" data-toggle="modal" data-target="#myModal2">
                            <span class="label label-danger" v-if="unreadNotificationsCount > 0">{{ unreadNotificationsCount }}</span>
                            </a>
                        </li>
                        <!-- User Account: style can be found in dropdown.less -->
                        <li class="dropdown notifications-menu">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                            <img v-if="userInfo.profile_pic !=null && userInfo.profile_pic !=''" :src="`${userInfo.profile_pic}`" class="user-image" alt="User Image">
                            <img v-if="userInfo.profile_pic ==null || userInfo.profile_pic ==''" src="../../assets/img/default.png" class="user-image" alt="User Image">
                            <i class="fa fa-caret-down ml-5" aria-hidden="true"></i>
                            <span class="hidden-xs"></span>
                            </a>
                            <ul class="dropdown-menu logmenu" style="width: 210px;">
                            <li>
                                <ul class="menu">
                                <li>
                                    <a @click="profile">Manage Profile</a>
                                </li>
                                <li>
                                    <a @click="settings">Account Setting</a>
                                </li>
                                <li v-if="email=='mrinalini.v@screenit.io'">
                                  <a @click="admin_settings">Admin Setting</a>
                                </li>
                                <li>
                                    <a @click="logout">Signout</a>
                                </li>
                                </ul>
                            </li>
                            </ul>
                        </li>
                        <!-- Control Sidebar Toggle Button -->
                    </ul>
                    <div style="background: rgb(0 0 0 / 10%);" class="modal right fade" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel2">
                    <div class="modal-dialog1" role="document" style="padding-top: 0%;margin-top: 50px !important;height: 100% !important;">
                        <div class="modal-content">

                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><i style="padding-right: 8px;" class="uil uil-times" aria-hidden="true"></i></button>
                            <h5 style="padding: 8px;border-bottom: 1px solid;" class="modal-title" id="myModalLabel2">Notifications</h5>
                        </div>

                        <div class="modal-body">
                            <div>
                            <ul class="products-list product-list-in-box">
                                <li class="item" v-for="(x, index) in todaylist" :key="index">
                                <div class="product-info" @click="redirect(x.notification_type,x._id,x.post_id,x.interest_web_type)">
                                    <a style="color: #60ab2f;" href="javascript:void(0)" class="product-title">
                                    <span class="pull-right mins">
                                        {{ x.created_at | timeago }}
                                    </span>
                                    </a>
                                </div>
                                <div class="product-img">
                                    <!-- <img v-if="x.org_image !='' && x.org_image !=null" :src="`${x.org_image}`" class="direct-chat-img">
                                    <img v-if="x.org_image =='' || x.org_image ==null" src="../../assets/img/default.png" alt="Product Image"> -->
                                    <span class="circle-title" v-if="x.notification_type =='interest'">INT</span>
                                    <span class="circle-title" v-if="x.notification_type =='reschedule'">RSH</span>
                                    <span class="circle-title" v-if="x.notification_type =='schedule'">SCH</span>
                                    <span class="circle-title" v-if="x.notification_type =='feedback'">FDK</span>
                                    <span class="circle-title" v-if="x.notification_type =='tobeshedule'">TBS</span>
                                </div>
                                <div class="product-info" @click="redirect(x.notification_type,x._id,x.post_id,x.interest_web_type)">
                                    <span class="product-description" v-html="x.msg_html"></span>
                                </div>
                                </li>
                                <p v-if="yesterdaylist.length > 0" class="date-title">Yesterday</p>
                                <li class="item" v-for="(x, index) in yesterdaylist" :key="index">
                                <div class="product-img">
                                    <!-- <img v-if="x.org_image !='' && x.org_image !=null" :src="`${x.org_image}`" class="direct-chat-img">
                                    <img v-if="x.org_image =='' || x.org_image ==null" src="../../assets/img/default.png" alt="Product Image"> -->
                                    <span class="circle-title" v-if="x.notification_type =='interest'">INT</span>
                                    <span class="circle-title" v-if="x.notification_type =='reschedule'">RSH</span>
                                    <span class="circle-title" v-if="x.notification_type =='schedule'">SCH</span>
                                    <span class="circle-title" v-if="x.notification_type =='feedback'">FDK</span>
                                    <span class="circle-title" v-if="x.notification_type =='tobeshedule'">TBS</span>
                                </div>
                                <div class="product-info" @click="redirect(x.notification_type,x._id,x.post_id,x.interest_web_type)">
                                    <a style="color: #60ab2f;" href="javascript:void(0)" class="product-title">
                                    <span class="pull-right mins">
                                        {{ x.created_at | timeago }}
                                    </span>
                                    </a>
                                    <span class="product-description" v-html="x.msg_html"></span>
                                </div>
                                </li>
                            </ul>
                            <div v-for="(x1, index) in notificationlist" v-bind:key="index">
                                <p class="date-title">{{x1.date}}</p>
                                <ul class="products-list product-list-in-box">
                                <li class="item" v-for="(x, index) in x1.list" :key="index">
                                    <div class="product-img">
                                    <!-- <img v-if="x.org_image !='' && x.org_image !=null" :src="`${x.org_image}`" class="direct-chat-img">
                                    <img v-if="x.org_image =='' || x.org_image ==null" src="../../assets/img/default.png" alt="Product Image"> -->
                                    <span class="circle-title" v-if="x.notification_type =='interest'">INT</span>
                                    <span class="circle-title" v-if="x.notification_type =='reschedule'">RSH</span>
                                    <span class="circle-title" v-if="x.notification_type =='schedule'">SCH</span>
                                    <span class="circle-title" v-if="x.notification_type =='feedback'">FDK</span>
                                    <span class="circle-title" v-if="x.notification_type =='tobeshedule'">TBS</span>
                                    </div>
                                    <div class="product-info" @click="redirect(x.notification_type,x._id,x.post_id,x.interest_web_type)">
                                    <a style="color: #60ab2f;" href="javascript:void(0)" class="product-title">
                                        <span class="pull-right mins">
                                        {{ x.created_at | timeago }}
                                        </span>
                                    </a>
                                    <span class="product-description" v-html="x.msg_html"></span>
                                    </div>
                                </li>
                                </ul>
                            </div>
                            </div>
                        </div>

                        </div><!-- modal-content -->
                    </div><!-- modal-dialog -->
                    </div>
                </div>
            </div>
        </nav>
    </header>
    <div v-if="uploadId" class="modal fade in" id="modal-default" style="overflow: auto;display: block; padding-right: 17px;" >
      <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Interviewer Description ID</h4>
            </div>
            <div class="modal-body">
                <div class="form-group">
                  <div class="custom-file-upload">
                    <div v-if="resumefiles.length < 1" class="show-doc-empty">Select the File </div>
                    <div class="show-doc" v-if="resumefiles.length > 0">
                        <span class="doc-file pull-left" v-for="(x, i) in resumefiles.slice(0, 2)" :key="i"><span class="doc-name">{{x.name}} </span><i @click="removeUploading(x)" class="fa fa-times" style="color: #ccc;" aria-hidden="true"></i></span>
                    </div>
                    <label for="file1"><i class="uil uil-upload" aria-hidden="true"></i> Upload </label>
                    <input @change="fileUploads($event)" style="visibility: hidden;" type="file" id="file1" name="myfiles" />
                  </div>
                  <p style="color: red;margin: 3px 0 10px; font-size: 12px;">{{errormsg}}</p>
                  <p style="color: #aeaaaa;margin: 3px 0 10px;">Supported format (.pdf, .docx), Size (Max 2MB)</p>
                </div>
            </div>
            <div class="modal-footer">
              <button :disabled="resumefiles.length < 1"  type="button" @click="UploadID()" style="margin-right: 10px;"  class="btn btn-success">Submit</button>
              <button @click="resumefiles = []; uploadId = false;" type="button"  class="btn btn-default">Cancel</button>
            </div>
          </div>
      </div>
    </div>
    <div v-if="uploadJd" class="modal fade in" id="modal-default" style="overflow: auto;display: block; padding-right: 17px;" >
      <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Job Description JD</h4>
            </div>
            <div class="modal-body">
                <div class="form-group">
                  <div class="custom-file-upload">
                    <div v-if="resumefiles1.length < 1" class="show-doc-empty">Select the File </div>
                    <div class="show-doc" v-if="resumefiles1.length > 0">
                        <span class="doc-file pull-left" v-for="(x, i) in resumefiles1.slice(0, 2)" :key="i"><span class="doc-name">{{x.name}} </span><i @click="removeUploading1(x)" class="fa fa-times" style="color: #ccc;" aria-hidden="true"></i></span>
                    </div>
                    <label for="file1"><i class="uil uil-upload" aria-hidden="true"></i> Upload </label>
                    <input @change="fileUploads1($event)" style="visibility: hidden;" type="file" id="file1" name="myfiles" />
                  </div>
                  <p style="color: red;margin: 3px 0 10px; font-size: 12px;">{{errormsg}}</p>
                  <p style="color: #aeaaaa;margin: 3px 0 10px;">Supported format (.pdf, .docx), Size (Max 2MB)</p>
                </div>
            </div>
            <div class="modal-footer">
              <button :disabled="resumefiles1.length < 1"  type="button" @click="UploadJD()" style="margin-right: 10px;"  class="btn btn-success">Submit</button>
              <button @click="resumefiles1 = []; uploadJd = false;" type="button"  class="btn btn-default">Cancel</button>
            </div>
          </div>
      </div>
    </div>
    </div>
</template>

<script>
import addpost from '../addpost_v3'
import addpostjd from '../addpostjd_v3'
import router from '../../router/index'
import axios from 'axios'
import { BaseURLV3 } from '../../shared/classes'
import $ from 'jquery'
// import Vue from 'vue'
// import VueSocketIO from 'vue-socket.io'
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: 'http://localhost:8080'
// }))
export default {
  name: 'TheHeader',
  data () {
    return {
      unreadMessagesCount: 0,
      unreadNotificationsCount: 0,
      config: {},
      notificationlist: [],
      userInfo: [],
      token: '',
      todaylist: [],
      yesterdaylist: [],
      interval: '',
      url: '',
      showRole: false,
      email: '',
      BaseURL2: 'https://dev.10xfreshers.net/api',
      uploadId: false,
      uploadJd: false,
      resumefiles: [],
      resumefiles1: [],
      createPost: false,
      createPostJd: false,
      errormsg: ''
    }
  },
  components: {
    addpost, addpostjd
  },
  created () {
    this.url = this.$router.history.current.path
    this.userInfo = JSON.parse(localStorage.getItem('user__details'))
    console.log('this.userInfo ', this.userInfo)
    // this.interval = setInterval(function () {
    //   // this.getnotificount()
    //   this.$socket.emit('my-event', { data: 'hello' })
    // }.bind(this), 8000)
    // this.$socket.on('my-event', (data) => {
    //   console.log(data)
    // })
    var email = this.userInfo.email
    this.email = email
  },
  mounted () {
    this.$root.$on('navigate', (arg) => {
      this.url = arg
    })
  },
  methods: {
    navigation (tabs) {
      this.url = tabs
      router.push({ name: tabs })
    },
    logout () {
      clearInterval(this.interval)
      localStorage.clear()
      router.push({ name: 'LoginV3' })
      // const id = this.userInfo._id
      // clearInterval(this.interval)
      // this.config = {
      //   headers: {
      //     'content-type': 'application/json',
      //     Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      //   }
      // }
      // axios.get(BaseURLV3 + '/logout/' + id, this.config).then(response => {
      //   localStorage.clear()
      //   localStorage.setItem('setPassword', JSON.stringify(false))
      //   router.push({ name: 'Login' })
      // }).catch(e => {
      // })
    },
    profile () {
      router.push({ name: 'ProfileV3' })
    },
    iaas () {
      router.replace({ path: '/iaas_redirection/' + this.userInfo.email })
    },
    dashboard () {
      router.push({ name: 'DashboardV3' })
    },
    settings () {
      router.push({ name: 'SettingsV3' })
    },
    admin_settings () {
      router.push({ name: 'AdminSettingsV3' })
    },
    getnotificount () {
      // console.log(this.token)
      this.userInfo = JSON.parse(localStorage.getItem('user__details'))
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      const id = this.userInfo._id
      axios.get(BaseURLV3 + '/dashboard/get_notification_count/web/' + id, this.config).then(response => {
        this.unreadNotificationsCount = response.data.count
        // console.log(response)
      }).catch(e => {
        // console.log(e)
        clearInterval(this.interval)
        router.push({ name: 'Login' })
      })
    },
    getnotification () {
      const id = this.userInfo._id
      this.updatecount(id)
      axios.get(BaseURLV3 + '/dashboard/get_notification/web/' + id, this.config).then(response => {
        this.notificationlist = response.data.notificationDetails
        this.todaylist = response.data.today_notification_details
        this.yesterdaylist = response.data.yesterday_notification_details
      }).catch(e => {
      })
    },
    updatecount (nid) {
      axios.get(BaseURLV3 + '/dashboard/update_notification_count_status/web/' + nid, this.config).then(response => {
        this.unreadNotificationsCount = 0
      }).catch(e => {
      })
    },
    updatecountstatus (nid) {
      const id = this.userInfo._id
      axios.get(BaseURLV3 + '/dashboard/update_notification_status/web/' + nid + '/' + id, this.config).then(response => {
        this.unreadNotificationsCount = 0
      }).catch(e => {
      })
    },
    redirect (tabs, id, postid, type) {
      this.updatecountstatus(id)
      localStorage.setItem('postId', JSON.stringify(postid))
      $('#myModal2').modal('toggle')
      if (tabs === 'interest') {
        this.$root.$emit('notify', type)
        router.push({ name: 'Post', query: { type: type } })
      } else if (tabs === 'reschedule') {
        router.push({ name: 'Shedule' })
      } else if (tabs === 'feedback') {
        router.push({ name: 'Result' })
      }
    },
    fileUploads (e) {
      this.errormsg = ''
      console.log('check file ', e.target)
      $('.custom-file-upload').removeClass('is-invalid')
      this.resumefiles = []
      for (let k = 0; k < e.target.files.length; k++) {
        if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf') {
          if (e.target.files[k].size < '2000001') {
            this.resumefiles.push(e.target.files[k])
          } else {
            this.errormsg = 'Please upload the file with size <3 MB'
          }
        } else {
          this.errormsg = 'Please upload only pdf or doc format'
        }
      }
      $('#file1').val('')
      console.log('resumefiles', this.resumefiles)
    },
    removeUploading (index) {
      this.resumefiles.splice(index, 1)
    },
    fileUploads1 (e) {
      this.errormsg = ''
      console.log('check file ', e.target)
      $('.custom-file-upload').removeClass('is-invalid')
      this.resumefiles1 = []
      for (let k = 0; k < e.target.files.length; k++) {
        if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf') {
          if (e.target.files[k].size < '2000001') {
            this.resumefiles1.push(e.target.files[k])
          } else {
            this.errormsg = 'Please upload the file with size <3 MB'
          }
        } else {
          this.errormsg = 'Please upload only pdf or doc format'
        }
      }
      $('#file1').val('')
      console.log('resumefiles1', this.resumefiles1)
    },
    removeUploading1 (index) {
      this.resumefiles1.splice(index, 1)
    },
    UploadID () {
      this.uploadId = false
      this.createPost = true
    },
    UploadJD () {
      this.uploadJd = false
      this.createPostJd = true
    },
    onclose () {
      this.createPost = false
      this.createPostJd = false
      console.log('enter onclose------------')
      // router.push({ name: 'DashboardV3' })
    }
  }
}
</script>

<style scoped>
.skin-blue .main-header .navbar .nav>li>a {
    color: #5bad2b;
    background-color: #32373C;
}
.skin-blue .main-header .navbar {
  background-color: #32373C;
  opacity: 1;
  border-bottom: 0.5px solid #32373C;
  color:black;
}
.sidebar-toggle:hover {
    background-color: #f1f1f1 !important;
}
.sidebar-toggle {
  color:black !important;
}
.skin-blue .main-header .navbar .nav>li>a:hover, .skin-blue .main-header .navbar .nav>li>a:active {
  background: #32373C;
  color: #5bad2b;
}
.skin-blue .main-header .navbar .nav>li>a {
    color: #fff;
}
.skin-blue .main-header .logo {
    background-color: #2D2D2D !important;
    color: #fff;
    border-bottom: 0 solid transparent;
    /* margin-bottom: 4px; */
}
.skin-blue .main-header li.user-header {
    background-color: #5bad2b;
}
.user-image {
  width: 30px !important;
  height: 30px !important;
  border-radius: 50%;
  margin-top: -5px !important;
  background-color: white;
}
/* start popup */
.modal.left .modal-dialog1,
.modal.right .modal-dialog1 {
  position: fixed;
  margin: auto;
  width: 320px;
  height: 100%;
  -webkit-transform: translate3d(0%, 0, 0);
      -ms-transform: translate3d(0%, 0, 0);
        -o-transform: translate3d(0%, 0, 0);
          transform: translate3d(0%, 0, 0);
}

.modal.left .modal-content,
.modal.right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.left .modal-body,
.modal.right .modal-body {
  padding: 15px 15px 80px;
}

/*Left*/
.modal.left.fade .modal-dialog1{
  left: -320px;
  -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
      -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
        -o-transition: opacity 0.3s linear, left 0.3s ease-out;
          transition: opacity 0.3s linear, left 0.3s ease-out;
}
.modal.left.fade.in .modal-dialog1{
  left: 0;
}
/*Right*/
.modal.right.fade .modal-dialog1 {
  right: -320px;
  -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
      -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
        -o-transition: opacity 0.3s linear, right 0.3s ease-out;
          transition: opacity 0.3s linear, right 0.3s ease-out;
}
.modal.right.fade.in .modal-dialog1 {
  right: 0;
}
/* ----- MODAL STYLE ----- */
.modal-content {
  border-radius: 0;
  border: none;
}

.modal-header {
  border-bottom-color: #EEEEEE;
  background-color: #FAFAFA;
}
.modal-dialog1 {
  width: 307px !important;
  margin: 0px auto !important;
  border-top: 3px solid #60AB2F;
}
.modal-header .close {
  margin-top: 4px;
}
.products-list .product-img img {
    width: 30px;
    height: 30px;
}
.products-list .product-info {
    margin-left: 49px;
}
.modal.right .modal-body {
    padding: 1px 5px 80px 1px;
}
.products-list .product-description {
  display: block;
  color: #999;
  overflow: hidden;
  word-wrap: break-word;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
}
.mins {
  color: #AEAEAE;
  font-weight: 100;
}
.product-description {
  font-size: 12px;
  color: #404040 !important;
}
.date-title {
  background-color: #f4f4f4;
  padding: 4px;
  width: 100%;
}
.logmenu>li .menu>li>a {
    padding: 6px !important;
    color: #444;
}
.logmenu>li .menu>li>a:hover {
    padding: 6px !important;
    color: #444;
    border-left: 3px solid #60AB2F;
}
.main-header {
  position: fixed;
  max-height: 100px;
  z-index: 1030;
  width: 100%;
}
.product-description {
  max-width: 200px;
  word-wrap: break-word !important;
  white-space: inherit !important;
}
.title-name {
  font-weight: 600 !important;
}
.job_title {
  font-weight: 600;
  color: #5bad2b !important;
}
span.job_title {
    color: #5bad2b !important;
}
.v-time-ago__text {
  font-size: 12px !important;
  cursor: pointer;
  color: #AEAEAE;
}
.mins {
  margin-top: -7px !important;
}
.span.v-time-ago__text {
    text-decoration: none;
    line-height: 20px;
    letter-spacing: .1px;
    letter-spacing: 0.09px;
    color: #AEAEAE;
    opacity: 1;
}
i.fa.fa-lg:hover {
    color: #5bad2b !important;
}
.products-list>.item {
  padding: 6px 0;
  border-left: 3px solid #ffffff;
  background: #fff;
  margin-left: 0px;
}
.products-list>.item:hover {
  padding: 6px 0;
  border-left: 3px solid #5bad2b;
  background: #f4f4f4;
  margin-left: 0px;
}
.modal-content {
  border-left: 1px solid #ccc;
}
.product-img {
    text-align: center;
}
.circle-title {
  height: 40px;
  widows: 40px;
  font-size: 12px;
  font-weight: 600;
  color: #B3B3B3;
  margin-left: -8px;
}
.products-list>.item:hover .product-img {
  background-color: #FFFFFF;
}
.product-img {
  height: 35px;
  width: 35px;
  background-color: #F1F1F1;
  border-radius: 25px;
  padding-top: 7px;
  margin-left: 7px;
}
.navbar-brand {
  padding: 9px 15px !important;
}
.iconUpload {
  font-size: 30px;
  color: #5bad2b;
}
.iconNameUpload {
  color: white;
}
.iconNameClass{
  padding: 10px;
  text-align: center;
}
.modal-header {
    padding: 8px;
}
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      max-height: calc(100vh - 40px);
      width: 501px;
  }
}
.roundedButton {
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid transparent;
  background-color: #5bad2b;
  color: white;
  padding: 6px;
}

</style>
